var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "test details 1b") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "test-details-1b",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#239FB5",
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7319,12.1108 C10.2099,12.1108 10.5969,12.4988 10.5969,12.9758 C10.5969,13.4538 10.2099,13.8408 9.7319,13.8408 L4.3209,13.8408 C3.8429,13.8408 3.4559,13.4538 3.4559,12.9758 C3.4559,12.4988 3.8429,12.1108 4.3209,12.1108 L9.7319,12.1108 Z M13.231,8.6508 C13.709,8.6508 14.095,9.0388 14.095,9.5158 C14.095,9.9938 13.709,10.3808 13.231,10.3808 L4.321,10.3808 C3.843,10.3808 3.456,9.9938 3.456,9.5158 C3.456,9.0388 3.843,8.6508 4.321,8.6508 L13.231,8.6508 Z M13.231,5.1909 C13.709,5.1909 14.095,5.5779 14.095,6.0559 C14.095,6.5339 13.709,6.9199 13.231,6.9199 L4.321,6.9199 C3.843,6.9199 3.456,6.5339 3.456,6.0559 C3.456,5.5779 3.843,5.1909 4.321,5.1909 L13.231,5.1909 Z M10.353,16.268 L15.826,10.807 L15.826,3.46 C15.826,2.506 15.049,1.731 14.095,1.731 L3.46,1.731 C2.506,1.731 1.73,2.506 1.73,3.46 L1.73,18.685 C1.73,19.639 2.506,20.415 3.46,20.415 L8.434,20.415 C8.609,20.415 8.762,20.48 8.899,20.57 L10.054,16.765 C10.111,16.578 10.213,16.407 10.353,16.268 Z M10.535,21.081 L14.429,20.099 L11.555,17.33 L10.535,21.081 Z M21.955,9.739 C23.349,11.133 23.349,13.402 21.955,14.796 L15.423,21.315 C15.278,21.46 15.097,21.566 14.899,21.621 L10.087,22.954 C9.983,22.982 9.875,22.997 9.769,22.997 C9.453,22.997 9.143,22.87 8.916,22.637 C8.77,22.487 8.671,22.303 8.62,22.108 C8.558,22.122 8.499,22.146 8.434,22.146 L3.46,22.146 C1.552,22.146 -6.92779167e-14,20.593 -6.92779167e-14,18.685 L-6.92779167e-14,3.46 C-6.92779167e-14,1.552 1.552,7.10542736e-15 3.46,7.10542736e-15 L14.095,7.10542736e-15 C16.003,7.10542736e-15 17.556,1.552 17.556,3.46 L17.556,9.229 C18.933,8.382 20.761,8.545 21.955,9.739 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestDetails);
export default __webpack_public_path__ + "static/media/test-details.04a088222d17bd2abd22be6115b0d78e.svg";
export { ForwardRef as ReactComponent };